module.exports = __webpack_public_path__ + "static/media/Duplicate.b7c70203.svg";